import { defineAction } from '~/prix'
import { z } from 'zod'
import operatorFetchAction from './operatorFetch.action.json' with { type: 'json' }
import { operatorObject } from '../operatorObject'

const operatorFetchDefinition = defineAction({
  ...operatorFetchAction,

  input: z.object({
    id: z.string().uuid(),
    includeInactivated: z.boolean().nullish(),
  }),
  output: operatorObject,
})

export default operatorFetchDefinition
